export default __webpack_public_path__ + "static/media/public_gists.d577d3ab.svg";